import React from 'react';

const PRAYER_ACCENT = { shacharit: '#1e3a5f', mincha: '#92400e', maariv: '#312e81' };

const formatCountdown = (secs) => {
  if (secs < 0) return 'עכשיו';
  if (secs < 60) return `עוד ${secs} שנ׳`;
  const m = Math.floor(secs / 60);
  const s = secs % 60;
  if (m < 60) return `עוד ${m}:${String(s).padStart(2, '0')}`;
  const h = Math.floor(m / 60);
  const rm = m % 60;
  return rm === 0 ? `עוד ${h} שע׳` : `עוד ${h}ש׳ ${rm}ד׳`;
};

const StatusBox = ({ msg, isError }) => (
  <div style={{
    width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center',
    direction: 'rtl', fontSize: '1rem', color: isError ? '#c0392b' : '#94a3b8',
  }}>
    {msg}
  </div>
);

/**
 * Board — פאנל מפוצל: שם התפילה + ספירה לאחור משמאל, שעה ענקית מימין.
 * מחיצה אנכית צבעונית מפרידה בין שני הצדדים.
 */
const Board = ({ nextMinyan, secondsLeft, upcomingPrayers, allPrayerTimes, title, showTitle, bgColor, loading, error }) => {
  if (loading) return <StatusBox msg="טוען..." />;
  if (error)   return <StatusBox msg={error} isError />;
  if (!nextMinyan) return <StatusBox msg="אין מנינים שנותרו להיום" />;

  const accent   = nextMinyan.color || PRAYER_ACCENT[nextMinyan.prayer] || '#0369a1';
  const countdown = formatCountdown(secondsLeft);

  return (
    <div style={{
      width: '100%', height: '100%', display: 'flex', flexDirection: 'column',
      direction: 'rtl', fontFamily: 'inherit', boxSizing: 'border-box',
      backgroundColor: bgColor || 'transparent',
    }}>
      {showTitle && (
        <div style={{
          padding: '0.6rem 1rem', flexShrink: 0,
          borderBottom: `2px solid ${accent}`,
        }}>
          <span style={{ fontWeight: 700, fontSize: '0.85rem', color: accent, letterSpacing: '0.02em' }}>
            {title}
          </span>
        </div>
      )}

      {/* Split panel */}
      <div style={{
        flex: 1, display: 'flex', flexDirection: 'row', alignItems: 'stretch',
      }}>
        {/* Left — prayer name + countdown */}
        <div style={{
          flex: '0 0 45%',
          display: 'flex', flexDirection: 'column',
          alignItems: 'center', justifyContent: 'center',
          padding: '1rem 0.75rem',
          gap: '0.5rem',
        }}>
          {/* Prayer name */}
          <div style={{
            fontSize: 'clamp(1.4rem, 4vw, 2.2rem)', fontWeight: 900,
            color: accent, letterSpacing: '-0.01em',
            textAlign: 'center', lineHeight: 1.1,
          }}>
            {nextMinyan.label}
          </div>

          {/* Countdown pill */}
          <div style={{
            fontSize: 'clamp(0.75rem, 2vw, 0.95rem)', fontWeight: 700,
            color: accent,
            backgroundColor: accent + '15',
            border: `1px solid ${accent}30`,
            borderRadius: 100,
            padding: '0.25rem 0.85rem',
            whiteSpace: 'nowrap',
            textAlign: 'center',
          }}>
            {countdown}
          </div>
        </div>

        {/* Divider */}
        <div style={{
          width: 3, flexShrink: 0,
          backgroundColor: accent,
          borderRadius: 2,
          margin: '12% 0',
          opacity: 0.35,
        }} />

        {/* Right — time */}
        <div style={{
          flex: 1,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          padding: '1rem 0.75rem',
        }}>
          <div style={{
            fontSize: 'clamp(2.5rem, 9vw, 5rem)', fontWeight: 900, lineHeight: 1,
            color: '#0f172a', fontVariantNumeric: 'tabular-nums',
            direction: 'ltr', letterSpacing: '-0.04em',
          }}>
            {nextMinyan.time}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Board;
